import React from 'react';
import './index.scss';

const HeaderComponent = ({ totalSites }) => {
  return (
    <div className="body_header">
      <div className="header_content">
        <div className="title">Order Details</div>
        {totalSites > 0 && (
          <div className="sub_title">
            {totalSites} Total {totalSites > 1 ? 'Sites' : 'Site'} Assigned{' '}
          </div>
        )}
      </div>
    </div>
  );
};

export default HeaderComponent;
